module.exports = __webpack_public_path__ + "solomon-islands.svg?85ba2391164081b44f940a01e9ead6b9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/solomon-islands.svg
// module id = 296
// module chunks = 10